// //core
import { BaseComponent } from './components/base.component';
import { ControlComponent } from './components/Core/control/control.component';

// layout
import { HeaderComponent } from './components/layout/header/header.component';
import { SideBarPanelComponent } from './components/layout/sidebarpanel/sidebarpanel.component';
import { HeaderProgressBarComponent } from './components/layout/headerprogressbar/headerprogressbar.component';

import { FooterComponent } from './components/layout/footer/footer.component';
import { PopupCompoentnt } from './components/layout/popup/popup.component';
import { ContentComponent } from './components/layout/content/content.component';
import { InterviewComponent } from './components/layout/interview/interview.component';
import { SideBarComponent } from './components/layout/sidebar/sidebar.component';
import { floaterComponent } from './components/layout/floater/floater.component';
import { ModalComponent } from './components/layout/modal/modal.component';
import { ProgressAccordionComponent } from './components/layout/progress-accordion/progress-accordion.component';
import { LoaderComponent } from './components/layout/loader/loader.component';

// general
import { UnMaskedComponent } from './components/general/unmasked-input/unmasked-input.component';
import { AlarmSystemComponent } from './components/general/alarm-system/alarm-system.component';
import { MaskedComponent } from './components/general/masked-input/masked-input.component';
import { ButtonLinkComponent } from './components/general/button-link/button-link.component';
import { RoundchevronComponent } from './components/general/round-chevron/roundchevron.component';
import { CustomHtmlCompnent } from './components/general/custom-html/custom-html.component';
import { SubSectionTitleComponent } from './components/general/sub-section-title/sub-section-title.component';
import { CustomTitle3Component } from './components/general/CustomTitle3/custom-title-3.component';
import { ProgressMeterComponent } from './components/general/progressmeter/progressmeter.component';
import { WellCarrierComponent } from './components/general/well-carrier/well-carrier.component';
import { CheckBoxComponent } from './components/general/Checkbox/check-box.component';
import { QuestionComponent } from './components/general/question/question.component';
import { TooltipComponent } from './components/general/tooltip/tooltip.component';
import { AuditingComponent } from './components/general/auditing/auditing.component';
import { SectiontitleComponent } from './components/general/section-title/section-title.components';
import { CustomButtonComponent } from './components/general/custom-button/custom-button.compoenent';
import { CustomButtonListComponent } from './components/general/custom-button-list/custom-button-list.component';
import { NumericStepperComponent } from './components/general/numeric-stepper/numeric-stepper.component';
import { MoreButtonComponent } from './components/general/more-button/more-button.component';
import { UnderWrittenComponent } from './components/general/under-written/under-written.component';
import {
	RoundImageContainerComponent,
	RoundImageNamePipe,
} from './components/general/round-image-container/round-image-container.component';
import { RoundImageComponent } from './components/general/round-image/round-image.component';
import { RoundImageMultiSelectComponent } from './components/general/round-image-multiselect/round-image-multiselect';
import { RadioButtonCompoent } from './components/general/radio-button/radio-button.component';
import { RadioCompoent } from './components/general/radio/radio.component';
import { DatepickerComponent } from './components/general/datepicker/datepicker.component';
import { DatepickerAccessibilityComponent } from './components/general/datepicker-accessibility/datepicker-accessibility.component';
import { AddressComponent } from './components/general/address/address.component';
import { PopoverAddressComponent } from './components/general/popover-address/popover-address.component';
import { AddressSubControlComponent } from './components/general/address/address-subcontrol.component';
import { DropDownComponent } from './components/general/dropdown/dropdown.components';
import { InsertNumberComponent } from './components/general/insert-number/insert-number.component';
import { CustomTextAreaComponent } from './components/general/custom-textarea/custom-textarea.component';
import { SepComponent } from './components/general/sep/sep.component';
import { CustomIconComponent } from './components/general/custom-icon/custom-icon.component';
import { ExistingAccountAccountComponent } from './components/general/existing-account/existing-account.component';
import { StyledButtonComponent } from './components/general/styled-button/styled-button.component';
import { StyledButtonsComponent } from './components/general/styled-buttons/styled-buttons.component';
import { QuestionGroupComponent } from './components/general/question-group/question-group.component';
import { FilledDataComponent } from './components/general/filled-data/filled-data.components';
import { PreloaderComponent } from './components/general/preloader/preloader.component';
import { ComparisonComponent } from './components/general/comparison/comparison.component';
import { InfoWeFoundComponent } from './components/general/info-we-found/info-we-found.component';
import { ExtendedInfoWeFoundComponent } from './components/general/extended-info-we-found/extended-info-we-found.component';
import { TalkWithusComponent } from './components/general/talk-with-us/talk-with-us.component';
import { SchedulepanelComponent } from './components/general/schedule-panel/schedule-panel.component';
import { QuoteComponent } from './components/general/Quote/Quote.component';
import { QuoteWithInfoProviderComponent } from './components/general/quote-with-provider-info/quote-with-provider-info.component';
import { CallMeNowComponent } from './components/general/call-me-now/call-me-now.component';
import { ProviderInfoComponent } from './components/general/provider-info/provider-info.component';
import { InfoBlockComponent } from './components/general/info-block/info-block.component';
import { CallProgressiveComponent } from './components/general/call-progressive/call-progressive.component';
import { MapComponent } from './components/general/map/map.component';
import { ClickListItemComponent } from './components/general/click-list-item/click-list-item.component';
import { MultiSelectComponent } from './components/general/multiselect/multiselect.component';
import { BreakComponent } from './components/general/break/break.component';
import { ClickListeningComponent } from './components/general/click-listening/click-listening.component';
import { ContentBorderComponent } from './components/general/content-border/content-border.component';
import { SecondaryOnlineBuyComponent } from './components/general/secondary-online-buy/secondary-online-buy.component';
import { TooltipHandlerComponent } from './components/general/tooltip-handler/tooltip-handler.component';
import { CoveragePackagesComponents } from './components/general/coverage-packages/coverage-packages.components';

// modules
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DpDatePickerModule } from 'ng2-date-picker';
import { CookieService } from 'ngx-cookie-service';
import { BlockUIModule } from 'ng-block-ui';
import { TextMaskModule } from 'angular2-text-mask';
import { NguiMapModule } from '@ngui/map';
import { MatNativeDateModule, MatDatepickerModule, DateAdapter, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

// internal
import { ROUTES } from './routing/routing';
import { servicesArr } from './Services/services';
import { AppComponent } from './app.component';
import { AllInterceptors } from './interceptors/interceptors';

// directives
import { GtmHandler } from './directives/gtm-handler/gtm-handler';
import { ToggleVisible } from './directives/toggle-visible';

// pipes
import { NoSanitizePipe } from './pipes/noSanitize.pipe';
import { EventsComponent } from './components/general/events/events.component';
import { EditAddressPageComponent } from './components/mpq3-dr/pages/edit-address/edit-address-page.component';
import { HeaderDr } from './components/mpq3-dr/layout/header-dr/header-dr.component';
import { ProgressMeterDrComponent } from './components/mpq3-dr/layout/progress-meter-dr/progress-meter-dr.component';
import { UpperSectionDrComponent } from './components/mpq3-dr/components/upper-section-dr/upper-section-dr.component';
import { AddressDisplayDrComponent } from './components/mpq3-dr/components/address-display-dr/address-display-dr.component';
import { FooterDrComponent } from './components/mpq3-dr/layout/footer-dr/footer-dr.component';
import { AddressCompareComponent } from './components/mpq3-dr/components/address-compare/address-compare.component';
import { AddressDisplayTextComponent } from './components/mpq3-dr/components/address-display-text/address-display-text.component';
import { AddressCompareCardComponent } from './components/mpq3-dr/components/address-compare-card/address-compare-card.component';
import { Mpq3DrPreloaderComponent } from './components/mpq3-dr/layout/mpq3-dr-preloader/mpq3-dr-preloader.component';
import { Mpq3DrLoaderStageComponent } from './components/mpq3-dr/layout/mpq3-dr-preloader/mpq3-dr-loader-stage/mpq3-dr-loader-stage.component';
import { InitInterviewComponent } from './components/general/init-interview/init-interview.component';
import { InfoWeFoundMvpComponent } from './components/general/info-we-found-mvp/info-we-found-mvp.component';
import { BuyingOptionsComponent } from './components/general/buying-options/buying-options.component';
import { MultiCheckboxComponent } from './components/general/multi-checkbox/multi-checkbox.component';
import { PreferencesRankingComponent } from './components/general/preferences-ranking/preferences-ranking.component';
import { CustomeScriptInjectionHtmlComponent } from './components/general/custome-script-injection-html/custome-script-injection-html.component';
import { DiscountCheckboxComponent } from './components/mpq3-dr/components/discount-checkbox/discount-checkbox.component';
import { CustomRouteReuseStrategy } from './routing/custom-route-reuse-strategy';
import { KickoutMfhExpertBoxComponent } from './components/general/kickout-mfh-expert-box/kickout-mfh-expert-box.component';
import { KickoutMfhCarrierBoxComponent } from './components/general/kickout-mfh-carrier-box/kickout-mfh-carrier-box.component';
import { AnalyzedElementComponent } from './components/general/analyzed-element/analyzed-element.component';
import { ResultPageToggleSectionComponent } from './components/layout/result-page-toggle-section/result-page-toggle-section.component';
import { CarriersBenefitsPopupComponent } from './components/general/carriers-benefits-popup/carriers-benefits-popup.component';
import { ConfigService } from './Services/config.service';
import { LayoutService } from './Services/layout/layout.service';
import { RatesDropdownComponent } from './components/general/rates-dropdown/rates-dropdown.component';
import { ChatBotDialogComponent } from './components/general/chat-bot-dialog/chat-bot-dialog.component';
import { BotMessageComponent } from './components/general/chat-bot-dialog/bot-message/bot-message.component';
import { SubmissionPreloaderPopupComponent } from './components/general/submission-preloader-popup/submission-preloader-popup.component';

@NgModule({
	declarations: [
		ModalComponent,
		BaseComponent,
		AppComponent,
		HeaderComponent,
		SideBarPanelComponent,
		HeaderProgressBarComponent,
		FooterComponent,
		PopupCompoentnt,
		ContentComponent,
		InterviewComponent,
		SideBarComponent,
		AlarmSystemComponent,
		floaterComponent,
		ProgressAccordionComponent,
		LoaderComponent,
		UnMaskedComponent,
		MaskedComponent,
		ButtonLinkComponent,
		RoundchevronComponent,
		CustomHtmlCompnent,
		SubSectionTitleComponent,
		CustomTitle3Component,
		ProgressMeterComponent,
		WellCarrierComponent,
		CoveragePackagesComponents,
		CheckBoxComponent,
		QuestionComponent,
		TooltipComponent,
		UnderWrittenComponent,
		AuditingComponent,
		SectiontitleComponent,
		CustomButtonComponent,
		CustomButtonListComponent,
		NumericStepperComponent,
		MoreButtonComponent,
		RoundImageContainerComponent,
		RoundImageNamePipe,
		RoundImageComponent,
		RoundImageMultiSelectComponent,
		RadioButtonCompoent,
		RadioCompoent,
		DatepickerComponent,
		DatepickerAccessibilityComponent,
		AddressComponent,
		PopoverAddressComponent,
		AddressSubControlComponent,
		DropDownComponent,
		RatesDropdownComponent,
		InsertNumberComponent,
		CustomTextAreaComponent,
		SepComponent,
		CustomIconComponent,
		ExistingAccountAccountComponent,
		StyledButtonComponent,
		StyledButtonsComponent,
		QuestionGroupComponent,
		FilledDataComponent,
		PreloaderComponent,
		ComparisonComponent,
		InfoWeFoundComponent,
		ExtendedInfoWeFoundComponent,
		InfoWeFoundMvpComponent,
		TalkWithusComponent,
		SchedulepanelComponent,
		QuoteComponent,
		QuoteWithInfoProviderComponent,
		CallMeNowComponent,
		ProviderInfoComponent,
		InfoBlockComponent,
		CallProgressiveComponent,
		CarriersBenefitsPopupComponent,
		MapComponent,
		ClickListItemComponent,
		MultiSelectComponent,
		BreakComponent,
		ClickListeningComponent,
		ContentBorderComponent,
		SecondaryOnlineBuyComponent,
		TooltipHandlerComponent,
		ControlComponent,
		ToggleVisible,
		GtmHandler,
		NoSanitizePipe,
		EventsComponent,
		EditAddressPageComponent,
		HeaderDr,
		ProgressMeterDrComponent,
		UpperSectionDrComponent,
		AddressDisplayDrComponent,
		FooterDrComponent,
		AddressCompareComponent,
		AddressDisplayTextComponent,
		AddressCompareCardComponent,
		Mpq3DrPreloaderComponent,
		Mpq3DrLoaderStageComponent,
		InitInterviewComponent,
		BuyingOptionsComponent,
		MultiCheckboxComponent,
		PreferencesRankingComponent,
		CustomeScriptInjectionHtmlComponent,
		DiscountCheckboxComponent,
		KickoutMfhExpertBoxComponent,
		KickoutMfhCarrierBoxComponent,
		AnalyzedElementComponent,
		ResultPageToggleSectionComponent,
		ChatBotDialogComponent,
		BotMessageComponent,
		SubmissionPreloaderPopupComponent,
	],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		TextMaskModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		NgSelectModule,
		CommonModule,
		BlockUIModule.forRoot(),
		DpDatePickerModule,
		RouterModule.forRoot(ROUTES),
		HttpClientModule,
		NgbModule,
		NguiMapModule,
		MatNativeDateModule,
		MatDatepickerModule,
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: (configService: ConfigService) => {
				return () => configService.loadConfig();
			},
			deps: [ConfigService],
			multi: true,
		},
		servicesArr,
		CookieService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AllInterceptors.AnalyticsInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AllInterceptors.ErrorkickoutInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AllInterceptors.LoaderInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AllInterceptors.SessionInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AllInterceptors.SessionTimeOutInterceptor,
			multi: true,
		},
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE],
		},
		{
			provide: RouteReuseStrategy,
			useClass: CustomRouteReuseStrategy,
		},
		LayoutService,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	entryComponents: [
		ModalComponent,
		BaseComponent,
		AppComponent,
		HeaderComponent,
		FooterComponent,
		PopupCompoentnt,
		ContentComponent,
		InterviewComponent,
		SideBarComponent,
		floaterComponent,
		ProgressAccordionComponent,
		LoaderComponent,
		UnMaskedComponent,
		AlarmSystemComponent,
		MaskedComponent,
		ButtonLinkComponent,
		RoundchevronComponent,
		CustomHtmlCompnent,
		CustomeScriptInjectionHtmlComponent,
		SubSectionTitleComponent,
		CustomTitle3Component,
		ProgressMeterComponent,
		WellCarrierComponent,
		CheckBoxComponent,
		QuestionComponent,
		TooltipComponent,
		AuditingComponent,
		SectiontitleComponent,
		CustomButtonComponent,
		CustomButtonListComponent,
		NumericStepperComponent,
		MoreButtonComponent,
		RoundImageContainerComponent,
		RoundImageComponent,
		RoundImageMultiSelectComponent,
		RadioButtonCompoent,
		RadioCompoent,
		DatepickerComponent,
		DatepickerAccessibilityComponent,
		AddressComponent,
		PopoverAddressComponent,
		// AddressSubControlComponent,
		DropDownComponent,
		RatesDropdownComponent,
		InsertNumberComponent,
		CustomTextAreaComponent,
		SepComponent,
		CustomIconComponent,
		ExistingAccountAccountComponent,
		StyledButtonComponent,
		StyledButtonsComponent,
		QuestionGroupComponent,
		FilledDataComponent,
		PreloaderComponent,
		ComparisonComponent,
		InfoWeFoundComponent,
		InfoWeFoundMvpComponent,
		ExtendedInfoWeFoundComponent,
		TalkWithusComponent,
		SchedulepanelComponent,
		QuoteComponent,
		QuoteWithInfoProviderComponent,
		CallMeNowComponent,
		ProviderInfoComponent,
		InfoBlockComponent,
		CallProgressiveComponent,
		CarriersBenefitsPopupComponent,
		MapComponent,
		ClickListItemComponent,
		MultiSelectComponent,
		BreakComponent,
		ClickListeningComponent,
		ContentBorderComponent,
		SecondaryOnlineBuyComponent,
		TooltipHandlerComponent,
		CoveragePackagesComponents,
		UnderWrittenComponent,
		UpperSectionDrComponent,
		AddressDisplayDrComponent,
		AddressCompareComponent,
		BuyingOptionsComponent,
		MultiCheckboxComponent,
		PreferencesRankingComponent,
		DiscountCheckboxComponent,
		KickoutMfhCarrierBoxComponent,
		KickoutMfhExpertBoxComponent,
		ResultPageToggleSectionComponent,
		ControlComponent,
		ChatBotDialogComponent,
		BotMessageComponent,
		SubmissionPreloaderPopupComponent,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
